var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Remove subdomain")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.subdomain
              ? _c("p", [
                  _vm._v(" Are you sure you wish to "),
                  _c("strong", [_vm._v("permanently")]),
                  _vm._v(
                    " remove the subdomain “" +
                      _vm._s(_vm.subdomain.domain) +
                      "”? "
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: "",
                  text: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Close")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteSubdomain
                }
              },
              [_vm._v("Remove")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }